import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import igbusinessLocales from '../../locales/igbusiness.json';
import igbusinessTemplatesLocales from '../../locales/igbusiness_templates.json';
import boardsLocales from '../../locales/board.json';
import bmcLocales from '../../locales/bmc.json';
import defaultLocales from '../../locales/default.json';
import RootStore from './stores/RootStore';
import NewActivity from './NewActivity';
import ActivityShow from './ActivityShow';
import { Provider, observer, inject } from 'mobx-react';
import FinalStep from './FinalStep';
import Index from './Index';
import ActivityEdit from './ActivityEdit';
import Header from './header';
import { Row, Col } from 'react-bootstrap';
// import {AUTH_EDIT, AUTH_SHOW} from './authorization';

addLocaleData([...es, ...en]);

import MainTooltips from '../common_components/tooltips/MainTooltips';
import TooltipStore from '../common_components/tooltips/TooltipStore';
import { TOOLTIPPROPS } from './constantsTooltips';
import { BUSINESS_ROUTE_PATH } from './constants.js';

@inject('rootStore', 'authorizationStore')
@observer
export default class Main extends React.Component {

  componentDidMount() {
    this.updatePrefix();
  }

  componentDidUpdate() {
    this.updatePrefix();
  }

  updatePrefix = () => {
    const {
      match: {
        params: {
          0: prefix
        }
      },
      rootStore
    } = this.props;

    rootStore.updatePathPrefix(prefix);
  }

  render() {
    const {
      emptyCurrentMVP,
      rootStore,
      authorizationStore,
      location: { pathname },
    } = this.props;
    const { loading } = rootStore;

    if (emptyCurrentMVP) {
      return (
        <div style={{ textAlign: 'center' }}>
          <h1>
            {this.rootStore.localeStore.intl.formatMessage({
              id: 'no_current_mvp',
            })}
            .
          </h1>
        </div>
      );
    }

    if (loading) {
      return (
        <div>
          <div className="loader-lg" />
        </div>
      );
    } else {
      return (
        <Row>
          <Col xs={12}>
            <Switch>
              <Route
                exact
                path={`${BUSINESS_ROUTE_PATH}/new/final_step`}
                component={authorizationStore.authEdit(FinalStep)}
              />
              <Route
                exact
                path={`${BUSINESS_ROUTE_PATH}/activities/:id/edit/final_step`}
                component={authorizationStore.authEdit(FinalStep)}
              />
              <Route
                path={`${BUSINESS_ROUTE_PATH}/new/:step`}
                component={authorizationStore.authEdit(NewActivity)}
              />
              <Route
                exact
                path={`${BUSINESS_ROUTE_PATH}/activities/:id/edit/:step`}
                component={authorizationStore.authEdit(ActivityEdit)}
              />
              <Route
                path={`${BUSINESS_ROUTE_PATH}/activities/:id`}
                component={authorizationStore.authShow(ActivityShow)}
              />
              <Route
                exact
                path={`${BUSINESS_ROUTE_PATH}/activities`}
                component={authorizationStore.authShow(Index)}
              />
              <Route component={authorizationStore.authShow(Index)} />
            </Switch>
          </Col>
        </Row>
      );
    }
  }
}
